import { FC, useEffect, useState } from 'react';
import { FieldRow, FieldLabel } from 'src/generic/component';
import { validate as nameTitleValidate, INameTitle } from 'src/types/org/common/nameTitleSchema';
import { IFieldErrors, ValidationError, ErrorManager, ERRORS_EMPTY } from 'src/types/validation';
import { IFieldProps, IFormProps } from 'src/generic/type/form';
import { Draft } from 'src/types/common';
import { Button, PrimaryButton } from '@cb/apricot-react';
import { Input } from 'src/generic/component/form';

export const NameTitleFields: FC<IFieldProps<INameTitle>> = ({ item: initial, errors, readOnly, original, showDiff, onUpdate }) => {
  const { getError, hasError } = ErrorManager(errors);

  const {
    name,
    title
  } = initial;

  const changed = (update: Draft<INameTitle>) => {
    if (onUpdate) {
      onUpdate({ ...initial, ...update });
    }
  };

  return (
    <div>
      <FieldRow>
        <FieldLabel variant="body1">Name</FieldLabel>
        <Input validation={hasError('name') ? 'error' : undefined} validationMsg={getError('name')}
          onChange={(e) => {
            changed({ name: e.target.value });
          }}
          disabled={readOnly}
          value={name || ''}
        />
      </FieldRow>
      <FieldRow>
        <FieldLabel variant="body1">Title</FieldLabel>
        <Input validation={hasError('title') ? 'error' : undefined} validationMsg={getError('title')}
          onChange={(e) => {
            changed({ title: e.target.value });
          }}
          disabled={readOnly}
          value={title || ''}
        />
      </FieldRow>
    </div>
  );
};

export const NameTitleForm: FC<IFormProps<INameTitle>> = ({ item, onComplete, onCancel }) => {
  const [validating, setValidating] = useState(false);

  const [draft, setDraft] = useState<Draft<INameTitle>>(item || {});

  useEffect(() => {
    setDraft(item || {});
  }, [item]);

  let errors: IFieldErrors = ERRORS_EMPTY;
  let validated: INameTitle | undefined = undefined;
  try {
    validated = nameTitleValidate(draft);
  } catch (error: any) {
    if (error instanceof ValidationError) {
      errors = error.fieldErrors;
    }
  }

  // Run submit logic handler
  const onSubmit = (e: any) => {
    e.preventDefault();
    setValidating(true);
    if (validated)
      onComplete(validated);
  };

  const onClose = () => {
    onCancel();
  };

  return (<div>
    <NameTitleFields
      item={draft}
      errors={validating ? errors : ERRORS_EMPTY}
      readOnly={false}
      onUpdate={(update) => { setDraft(update); }}
    />
    <PrimaryButton style={{ marginRight: '10px' }} onClick={onSubmit}>{item ? 'Update' : 'Add'}</PrimaryButton>
    <Button onClick={onClose}>Cancel</Button>
  </div>);
};